/* eslint-disable max-lines */
import { MuiThemeProvider } from '@material-ui/core/';
import Divider from '@material-ui/core/Divider/Divider';
import Tab from '@material-ui/core/Tab/Tab';
import Tabs from '@material-ui/core/Tabs/Tabs';
import TextField from '@material-ui/core/TextField/TextField';
import { customizerTheme } from 'assets/theme';
import { SvgIcon } from 'components/Shared/SvgIcon';
import { WithStyles } from 'decorators/withStyles';
import { IButton, IExitPopUp, IMedia, ITimer } from 'interfaces/IExitPopUp';
import * as React from 'react';
import { PureComponent } from 'react';
import { exitPopUpService } from 'services/exitPopUpService';
import { CDN_URL } from 'settings';

import ColorPicker from './ColorPicker';
import ImagePicker from './ImagePicker';
import VideoPicker from './VideoPicker';

interface IProps {
  classes?: any;
  exitPopUp?: IExitPopUp;
}

interface IState {
  tab: number;
  media: IMedia;
  timer: ITimer;
  button: IButton;
  timerTextSizeError: boolean;
  buttonTextSizeError: boolean;
}

@WithStyles(theme => ({
  addButton: {
    backgroundColor: theme.variables.colors['title'],
    color: '#FFF',
    textTransform: 'none',
    fontSize: 16,
    fontWeight: 'bold',
    margin: '8px 0',
    '&:hover': {
      backgroundColor: theme.variables.colors['customizerTitle']
    }
  },
  removeButton: {
    color: '#DC3F53',
    textTransform: 'none',
    fontSize: 16,
    fontWeight: 'bold',
    margin: '8px 0',
    border: '2px solid #DC3F53',
    padding: '6px 20px',
    '&:hover': {
      backgroundColor: 'transparent',
      color: '#c33345',
      borderColor: '#c33345'
    }
  },
  imageTitle: {
    fontSize: 16,
    marginTop: 4
  },
  buttons: {
    display: 'flex',
    justifyContent: 'space-between'
  },

  subtitle: {
    color: '#596375',
    fontWeight: 'bold',
    fontSize: 18,
    margin: '0 0 8px 0'
  },
  divider: {
    margin: '18px 0'
  },
  textField: {
    margin: '12px 0',
    width: '100%'
  }
}))
export default class ExitPopUp extends PureComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    const { button, timer, media } = props.exitPopUp;

    this.state = { button, timer, media, tab: 0, timerTextSizeError: false, buttonTextSizeError: false };
  }

  onChangeBackgroundButton = (color: string) => {
    const { button } = this.props.exitPopUp;
    const { exitPopUp } = this.props;
    const newExitPopUp: IExitPopUp = {
      ...exitPopUp,
      button: {
        ...button,
        theme: {
          ...button.theme,
          backgroundColor: color.slice(1)
        }
      }
    };

    exitPopUpService.changeExitPopUp(newExitPopUp);
  };

  onChangeBackgroundButtonHover = (color: string) => {
    const { button } = this.props.exitPopUp;
    const { exitPopUp } = this.props;
    const newExitPopUp: IExitPopUp = {
      ...exitPopUp,
      button: {
        ...button,
        theme: {
          ...button.theme,
          backgroundColorHover: color.slice(1)
        }
      }
    };

    exitPopUpService.changeExitPopUp(newExitPopUp);
  };

  onChangeTextColorButton = (color: string) => {
    const { button } = this.props.exitPopUp;
    const { exitPopUp } = this.props;
    const newExitPopUp: IExitPopUp = {
      ...exitPopUp,
      button: {
        ...button,
        theme: {
          ...button.theme,
          textColor: color.slice(1)
        }
      }
    };

    exitPopUpService.changeExitPopUp(newExitPopUp);
  };

  onChangeTextSizeButton = (event: any) => {
    const { button } = this.props.exitPopUp;
    const { exitPopUp } = this.props;
    const newExitPopUp: IExitPopUp = {
      ...exitPopUp,
      button: {
        ...button,
        theme: {
          ...button.theme,
          textSize: event.target.value
        }
      }
    };

    const errorSize = this.checkSizeText(event.target.value);
    this.setState({ buttonTextSizeError: errorSize });

    exitPopUpService.changeExitPopUp(newExitPopUp);
  };

  onChangeTimerBackgroundColor = (color: string) => {
    const { timer } = this.props.exitPopUp;
    const { exitPopUp } = this.props;
    const newExitPopUp: IExitPopUp = {
      ...exitPopUp,
      timer: {
        ...timer,
        theme: {
          ...timer.theme,
          backgroundColor: color.slice(1)
        }
      }
    };

    exitPopUpService.changeExitPopUp(newExitPopUp);
  };

  onChangeTimerTitleColor = (color: string) => {
    const { timer } = this.props.exitPopUp;
    const { exitPopUp } = this.props;
    const newExitPopUp: IExitPopUp = {
      ...exitPopUp,
      timer: {
        ...timer,
        theme: {
          ...timer.theme,
          titleColor: color.slice(1)
        }
      }
    };

    exitPopUpService.changeExitPopUp(newExitPopUp);
  };

  checkSizeText = (size: number) => {
    let errorSize = size > 96 ? true : false;
    if (size < 9) {
      errorSize = true;
    }
    return errorSize;
  };

  onChangeTimerTitleSize = (event: any) => {
    const { timer } = this.props.exitPopUp;
    const { exitPopUp } = this.props;
    const newExitPopUp: IExitPopUp = {
      ...exitPopUp,
      timer: {
        ...timer,
        theme: {
          ...timer.theme,
          titleSize: event.target.value
        }
      }
    };

    const errorSize = this.checkSizeText(event.target.value);
    this.setState({ timerTextSizeError: errorSize });

    exitPopUpService.changeExitPopUp(newExitPopUp);
  };

  onChangeVideo = (video: string) => {
    const { exitPopUp } = this.props;
    const { media } = exitPopUp;
    const newExitPopUp: IExitPopUp = {
      ...exitPopUp,
      media: {
        ...media,
        video
      }
    };

    exitPopUpService.changeExitPopUp(newExitPopUp);
  };

  onChangeImage = (image: string) => {
    const { media } = this.props.exitPopUp;
    const { exitPopUp } = this.props;
    const newExitPopUp: IExitPopUp = {
      ...exitPopUp,
      media: {
        ...media,
        image
      }
    };

    exitPopUpService.changeExitPopUp(newExitPopUp);
  };

  onChangeTab = (event: any, value: number) => {
    this.setState({ tab: value });
  };

  showImage = (image: string) => {
    if (!image) {
      return '';
    }
    return image.startsWith('/') ? `${CDN_URL}${image}` : `${image}`;
  };

  render() {
    const { tab } = this.state;
    const { classes, exitPopUp } = this.props;

    const recomendations = {
      desktop: {
        width: 600,
        height: 450
      },
      mobile: {
        width: 600,
        height: 500
      }
    };

    if (!exitPopUp) {
      return null;
    }
    const { button, timer, media } = this.props.exitPopUp;

    return (
      <MuiThemeProvider theme={customizerTheme}>
        <div>
          <Tabs value={tab} onChange={this.onChangeTab} fullWidth indicatorColor="secondary" textColor="secondary">
            <Tab icon={<SvgIcon name="image" />} label="Imagem" />
            <Tab icon={<SvgIcon name="video" />} label="Vídeo" />
          </Tabs>

          {tab === 0 && (
            <div>
              <ImagePicker
                recomendations={recomendations.desktop}
                onChangeImage={this.onChangeImage}
                image={this.showImage(media.image)}
                previewDimensions={{ width: '100%', height: '150px' }}
              />
            </div>
          )}

          {tab === 1 && <VideoPicker video={media.video} onChangeVideo={this.onChangeVideo} />}
        </div>

        <div className={classes.subtitle}>Botão</div>
        <ColorPicker
          value={button.theme.backgroundColor}
          label="Cor do botão"
          handleChangeColor={this.onChangeBackgroundButton}
        />

        <ColorPicker
          value={button.theme.backgroundColorHover}
          label="Cor ao passar o mouse"
          handleChangeColor={this.onChangeBackgroundButtonHover}
        />

        <ColorPicker
          value={button.theme.textColor}
          label="Cor do texto"
          handleChangeColor={this.onChangeTextColorButton}
        />

        <TextField
          label="Tamanho do texto"
          type="number"
          helperText="Tamanho aceito de 9 a 96"
          onChange={this.onChangeTextSizeButton}
          error={this.state.buttonTextSizeError}
          value={button.theme.textSize}
          classes={{ root: classes.textField }}
          InputProps={{ inputProps: { min: 9, max: 96 } }}
        >
          {button.theme.textSize}
        </TextField>

        <div className={classes.divider}>
          <Divider />
        </div>

        <div className={classes.subtitle}>Relógio</div>
        <ColorPicker
          value={timer.theme.backgroundColor}
          label="Cor do fundo do relógio"
          handleChangeColor={this.onChangeTimerBackgroundColor}
        />

        <ColorPicker
          value={timer.theme.titleColor}
          label="Cor do texto"
          handleChangeColor={this.onChangeTimerTitleColor}
        />

        <TextField
          label="Tamanho do texto"
          helperText="Tamanho aceito de 9 a 96"
          type="number"
          error={this.state.timerTextSizeError}
          onChange={this.onChangeTimerTitleSize}
          value={timer.theme.titleSize}
          classes={{ root: classes.textField }}
          InputProps={{ inputProps: { min: 9, max: 96 } }}
        >
          {timer.theme.titleSize}
        </TextField>
      </MuiThemeProvider>
    );
  }
}
